import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NumberToDatePipe } from './number-to-date.pipe';
import { NumberToTimePipe } from './number-to-time.pipe';
import { SdmDatePipe } from './sdm-date.pipe';
import { SdmTimePipe } from './sdm-time.pipe';
import { StringToTimePipe } from './string-to-time.pipe';
import { NumberToHourPipe } from './number-to-hour.pipe';
import { NumberToTimePipeLISTA } from './number-to-time-LISTA.pipe';


@NgModule({
  declarations: [
    NumberToDatePipe,
    NumberToTimePipe,
    SdmDatePipe,
    SdmTimePipe,
    StringToTimePipe,
    NumberToHourPipe,
    NumberToTimePipeLISTA
  ],
  exports: [
    NumberToDatePipe,
    NumberToTimePipe,
    SdmDatePipe,
    SdmTimePipe,
    StringToTimePipe,
    NumberToHourPipe,
    NumberToTimePipeLISTA
  ],
  imports: [
    CommonModule
  ]
})
export class SharedPipesModule { }
